import React, { useState } from 'react';

import { DateColumn } from 'leeloo-react/component/dataTable/column/DateColumn';
import { EditorColumn } from 'leeloo-react/component/dataTable/column/EditorColumn';
import { SimpleColumn } from 'leeloo-react/component/dataTable/column/SimpleColumn';
import { DataTable } from 'leeloo-react/component/dataTable/DataTable';
import { Filter } from 'leeloo-react/component/filter/Filter';
import { InputField } from 'leeloo-react/component/form/field/InputField';
import { useDataSource } from 'leeloo-react/component/hook/useDataSource';

import { ResourceDataProviderEnum } from '../../../../enum/ResourceDataProviderEnum';
import { RouteEnum } from '../../../../enum/RouteEnum';
import { CustomFilterDataProviderType } from '../../../../model/dataProvider/CustomFilterDataProviderType';
import { LengthColumn } from '../../../dataTable/column/LengthColumn';
import { DataTableBulksActions } from '../../../dataTable/DataTableBulksActions';
import { DataTableHeaderActions } from '../../../dataTable/DataTableHeaderActions';
import { DataTableListActions } from '../../../dataTable/DataTableListActions';
import { SwitchField } from '../../../form/SwitchField';

type SessionDataTableProps = {
    training?: null,
}

export function SessionDataTable(props: SessionDataTableProps) {
  const [filters, setFilters] = useState<CustomFilterDataProviderType>({ training: props.training });
  const dsSessions = useDataSource({
    resource: ResourceDataProviderEnum.session,
    params: {
      pagination: { page: 1, take: 50 },
      filter: { training: props.training },
    },
  });

  const exportNameFile = 'sessions_formation.csv';

  return (
    <DataTable
      dataSource={dsSessions}
      filter={(
        <Filter>
          <InputField name="search" label="Rechercher" onChangeValue={(v) => setFilters({ ...filters, ...{ search: v } })} />
        </Filter>
      )}
      actionHeader={(
        <DataTableHeaderActions
          addRoute={props.training ? RouteEnum.ADMIN_SESSION_ADD_TRAINING : RouteEnum.ADMIN_SESSION_ADD}
          addRouteParams={{ training: props.training ?? '' }}
          addRouteValue="Créer une session de formation"
          importResource={ResourceDataProviderEnum.sessionImport}
          exportResource={ResourceDataProviderEnum.sessionExport}
          exportNameFile={exportNameFile}
          exportFilters={filters}
          dataSource={dsSessions}
        />

      )}
      actionRow={(row) => [
        <DataTableListActions
          key={0}
          row={row}
          dataSource={dsSessions}
          readRoute={RouteEnum.ADMIN_SESSION_SHOW}
          deleteResource={ResourceDataProviderEnum.session}
          duplicateResource={ResourceDataProviderEnum.sessionDuplicate}
          editRoute={RouteEnum.ADMIN_SESSION_EDIT}
        />,
      ]}
      onChangeCheckedRow={(rows: {id: number|string}[], cleanSelection) => (
        <DataTableBulksActions
          rows={rows}
          dataSource={dsSessions}
          deleteResource={ResourceDataProviderEnum.session}
          duplicateResource={ResourceDataProviderEnum.sessionDuplicate}
          exportResource={ResourceDataProviderEnum.sessionExport}
          exportNameFile={exportNameFile}
          cleanSelection={cleanSelection}
        />
      )}
    >
      <SimpleColumn field="training.title" title="Action de formation" />
      <SimpleColumn field="location.town" title="Ville" />
      <SimpleColumn field="former.lastName" title="Formateur" />
      <SimpleColumn field="contactSessionsCount" title="Inscrits" />
      <DateColumn field="dateStart" title="Date de début" sortable />
      <DateColumn field="dateEnd" title="Date de fin" sortable />
      <SimpleColumn field="conditions" title="État" sortable />
      <EditorColumn
        field="status"
        title="Status"
        resource={ResourceDataProviderEnum.sessionUpdateStatus}
        columnElement={SimpleColumn}
        inputElement={<SwitchField />}
        center
        sortable
        forceEditable
      />
    </DataTable>
  );
}

SessionDataTable.defaultProps = {
  training: null,
};
